module.exports = __webpack_public_path__ + "static/Digital-Pharmacy-f6afc8ecfc3f2088cb069997adba0a8e.jpg";